<nb-card accent="{{ status() }}">
  <nb-card-body>
    <div *ngIf="ans.type === 'text'" class="text-body text-answer">
      {{ ans.content }}
    </div>

    <ngx-view-image
      *ngIf="ans.type === 'image'"
      [imageURL]="ans.content"
    ></ngx-view-image>

    <ngx-view-video
      *ngIf="ans.type === 'video'"
      [url]="ans.content"
    ></ngx-view-video>

    <ngx-view-document *ngIf="ans.type === 'document'" [content]="ans.content">
    </ngx-view-document>

    <div
      *ngIf="
        ans.type !== 'text' &&
        ans.type !== 'image' &&
        ans.type !== 'video' &&
        ans.type !== 'document'
      "
      class="text-body text-answer"
    >
      <ngx-view-document
        *ngIf="ans.type === 'document'"
        [content]="ans.content"
      >
      </ngx-view-document>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      *ngIf="ans.selected"
      nbButton
      fullWidth
      size="small"
      status="{{ status() }}"
      (click)="selected()"
    >
      <nb-icon icon="checkmark-circle-2"></nb-icon>
    </button>

    <button
      *ngIf="!ans.selected"
      nbButton
      fullWidth
      size="small"
      status="{{ status() }}"
      (click)="selected()"
    >
      <nb-icon icon="radio-button-off-outline"></nb-icon>
    </button>
  </nb-card-footer>
</nb-card>
